<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    @keydown.enter="agree"
  >
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <v-card>
        <v-toolbar dark :color="options.color" dense flat>
          <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-show="!!message" class="pa-4">
          {{ message }}
        </v-card-text>
        <v-card-text>
          <slot name="textSlot"></slot>
          <v-form>
            <v-row>
              <v-col cols="12">
                <ValidationProvider
                  name="Refund Payment Method"
                  v-slot="{ errors }"
                  :rules="{ required: true }"
                >
                  <custom-label item-field-name="Refund Payment Method" />
                  <PaymentMethodSelection
                    v-model="model.voidedPaymentMethod"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider name="Remark">
                  <custom-label item-field-name="Remark" />
                  <v-text-field v-model="model.voidedRemarks" outlined flat />
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click.native="cancel">Cancel</v-btn>
          <v-btn color="error darken-1" text @click.native="agree">{{ confirmBtn }}</v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import PaymentMethodSelection from '@/components/PaymentMethodSelection.vue';
import CustomLabel from '@/components/customFormLabel/customLabel';

export default {
  name: 'VoidDialog',
  components: {
    CustomLabel,
    PaymentMethodSelection,
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    confirmBtn: null,
    options: {
      color: 'error',
      width: 500,
      zIndex: 200,
    },
    model: {
      voidedPaymentMethod: null,
      voidedRemarks: null,
    },
  }),
  methods: {
    open(title = 'Void', message, options, confirmBtn) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.confirmBtn = confirmBtn || 'Confirm';
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    async agree() {
      if (!(await this.$refs.form.validate())) {
        return;
      }
      this.resolve(this.model);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
